import {
  checkIfFeedbackGiven,
  clearLiveEvent,
  getLiveEvent,
  getLiveEventAttendees,
  getLiveEventPhotos,
  refreshLiveEvent,
  refreshLiveEventAttendees,
  refreshLiveEventPhotos,
  submitFeedback,
  submitNoFeedback,
} from "../../actions/liveEventActions";

import { LiveEventState } from "../../../types/redux";
import _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  success: false,
  data: null,
  refreshing: false,
  attendees: {
    loading: false,
    refreshing: false,
    error: null,
    success: false,
    data: [],
  },
  photos: {
    loading: false,
    refreshing: false,
    error: null,
    success: false,
    data: [],
  },
  eventFeedback: {
    loading: false,
    error: null,
    success: false,
    data: null,
    type: "",
  },
  feedbackGiven: {
    loading: false,
    error: null,
    success: false,
    data: null,
    type: "",
  },
} as LiveEventState;

const liveEventSlice = createSlice({
  name: "live-event",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getLiveEvent.fulfilled, (state, action) => {
      state.loading = false;
      state.success = true;
      state.error = null;
      if (!_.isEqual(state.data, action.payload.result)) {
        state.data = action.payload.result;
      }
    });
    builder.addCase(getLiveEvent.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getLiveEvent.rejected, (state, action) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
      state.data = null;
    });
    builder.addCase(refreshLiveEvent.fulfilled, (state, action) => {
      state.refreshing = false;
      state.error = null;
      if (!_.isEqual(state.data, action.payload.result)) {
        state.data = action.payload.result;
      }
    });
    builder.addCase(refreshLiveEvent.pending, (state) => {
      state.refreshing = true;
    });
    builder.addCase(refreshLiveEvent.rejected, (state, action) => {
      state.loading = false;
      state.refreshing = false;
      state.success = false;
      state.error = action.payload;
      state.data = null;
    });
    builder.addCase(getLiveEventAttendees.fulfilled, (state, action) => {
      state.attendees.loading = false;
      state.attendees.success = true;
      state.attendees.error = null;
      if (!_.isEqual(state.data, action.payload.result)) {
        state.attendees.data = action.payload.result;
      }
    });
    builder.addCase(getLiveEventAttendees.pending, (state) => {
      state.attendees.loading = true;
    });
    builder.addCase(getLiveEventAttendees.rejected, (state, action) => {
      state.attendees.loading = false;
      state.attendees.success = false;
      state.attendees.error = action.payload;
      state.attendees.data = [];
    });
    builder.addCase(refreshLiveEventAttendees.fulfilled, (state, action) => {
      if (!_.isEqual(state.data, action.payload.result)) {
        state.attendees.data = action.payload.result;
      }
      state.attendees.refreshing = false;
      state.attendees.error = null;
      state.attendees.success = true;
    });
    builder.addCase(refreshLiveEventAttendees.pending, (state) => {
      state.attendees.refreshing = true;
    });
    builder.addCase(refreshLiveEventAttendees.rejected, (state, action) => {
      state.attendees.loading = false;
      state.attendees.success = false;
      state.attendees.refreshing = false;
      state.attendees.error = action.payload;
      state.attendees.data = [];
    });
    builder.addCase(getLiveEventPhotos.fulfilled, (state, action) => {
      state.photos.loading = false;
      state.photos.success = true;
      state.photos.error = null;
      if (!_.isEqual(state.data, action.payload.result)) {
        state.photos.data = action.payload.result;
      }
    });
    builder.addCase(getLiveEventPhotos.pending, (state) => {
      state.photos.loading = true;
    });
    builder.addCase(getLiveEventPhotos.rejected, (state, action) => {
      state.photos.loading = false;
      state.photos.success = false;
      state.photos.error = action.payload;
      state.photos.data = [];
    });
    builder.addCase(refreshLiveEventPhotos.fulfilled, (state, action) => {
      state.photos.refreshing = false;
      state.photos.error = null;
      state.photos.success = true;
      if (!_.isEqual(state.data, action.payload.result)) {
        state.photos.data = action.payload.result;
      }
    });
    builder.addCase(refreshLiveEventPhotos.pending, (state) => {
      state.photos.refreshing = true;
    });
    builder.addCase(refreshLiveEventPhotos.rejected, (state, action) => {
      state.photos.loading = false;
      state.photos.success = false;
      state.photos.refreshing = false;
      state.photos.error = action.payload;
      state.photos.data = [];
    });

    builder.addCase(submitFeedback.fulfilled, (state, action) => {
      state.eventFeedback.error = null;
      state.eventFeedback.success = true;
      state.eventFeedback.loading = false;
      state.eventFeedback.type = action.type;
      if (!_.isEqual(state.data, action.payload.result)) {
        state.eventFeedback.data = action.payload.result;
      }
    });
    builder.addCase(submitFeedback.pending, (state) => {
      state.eventFeedback.loading = true;
    });
    builder.addCase(submitFeedback.rejected, (state, action) => {
      state.eventFeedback.loading = false;
      state.eventFeedback.success = false;
      state.eventFeedback.error = action.payload;
      state.eventFeedback.data = null;
    });
    builder.addCase(submitNoFeedback.fulfilled, (state, action) => {
      state.eventFeedback.error = null;
      state.eventFeedback.success = true;
      state.eventFeedback.loading = false;
      state.eventFeedback.type = action.type;
      if (!_.isEqual(state.data, action.payload.result)) {
        state.eventFeedback.data = action.payload.result;
      }
    });
    builder.addCase(submitNoFeedback.pending, (state) => {
      state.eventFeedback.loading = true;
    });
    builder.addCase(submitNoFeedback.rejected, (state, action) => {
      state.eventFeedback.loading = false;
      state.eventFeedback.success = false;
      state.eventFeedback.error = action.payload;
      state.eventFeedback.data = null;
    });

    builder.addCase(checkIfFeedbackGiven.fulfilled, (state, action) => {
      state.feedbackGiven.error = null;
      state.feedbackGiven.success = true;
      state.feedbackGiven.loading = false;
      state.feedbackGiven.type = action.type;
      if (!_.isEqual(state.data, action.payload.result)) {
        state.feedbackGiven.data = action.payload.result;
      }
    });
    builder.addCase(checkIfFeedbackGiven.pending, (state) => {
      state.feedbackGiven.loading = true;
    });
    builder.addCase(checkIfFeedbackGiven.rejected, (state, action) => {
      state.feedbackGiven.loading = false;
      state.feedbackGiven.success = false;
      state.feedbackGiven.error = action.payload;
      state.feedbackGiven.data = null;
    });

    builder.addCase(clearLiveEvent, (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.data = null;
      state.refreshing = false;
      state.attendees = {
        loading: false,
        refreshing: false,
        error: null,
        success: false,
        data: [],
      };
      state.photos = {
        loading: false,
        refreshing: false,
        error: null,
        success: false,
        data: [],
      };
      state.eventFeedback = {
        loading: false,
        error: null,
        success: false,
        data: null,
        type: "",
      };
      state.feedbackGiven = {
        loading: false,
        error: null,
        success: false,
        data: null,
        type: "",
      };
    });
  },
});

export default liveEventSlice.reducer;
